import React from 'react';
import { Link } from 'react-router-dom';
import './SiloNavigation.css';

const SiloNavigation = () => {
    const categories = [
        { label: "Cakes", href: "/cakes" },
        { label: "Birthday Cakes", href: "/birthday-cakes" },
        { label: "Anniversary Cakes", href: "/anniversary-cakes" },
        { label: "Photo Cakes", href: "/photo-cakes" },
        { label: "Designer Cakes", href: "/designer-cakes" },
        { label: "Theme Cakes", href: "/theme-cakes" },
        { label: "Kids Cakes", href: "/kids-cakes" },
        { label: "Chocolate Cakes", href: "/chocolate-cakes" },
        { label: "Red Velvet Cakes", href: "/red-velvet-cakes" },
        { label: "Butterscotch Cakes", href: "/butterscotch-cakes" }
    ];

    const recipients = [
        { label: "Cakes for Kids", href: "/cakes-for-kids" },
        { label: "Cakes for Girlfriend", href: "/cakes-for-girlfriend" },
        { label: "Cakes for Boyfriend", href: "/cakes-for-boyfriend" },
        { label: "Cakes for Wife", href: "/cakes-for-wife" },
        { label: "Cakes for Husband", href: "/cakes-for-husband" },
        { label: "Cakes for Sister", href: "/cakes-for-sister" },
        { label: "Cakes for Brother", href: "/cakes-for-brother" },
        { label: "Cakes for Friend", href: "/cakes-for-friend" }
    ];

    const occasions = [
        { label: "Valentines Day", href: "/valentine-day-cakes" },
        { label: "Mothers Day", href: "/cakes/mothers-day-cakes" },
        { label: "Fathers Day", href: "/cakes/fathers-day-cakes" },
        { label: "Rakhi Cakes", href: "/rakhi" },
        { label: "Holi Cakes", href: "/holi-cakes" },
        { label: "Diwali Cakes", href: "/diwali-cakes" },
        { label: "Christmas Cakes", href: "/christmas-cakes" },
        { label: "New Year Cakes", href: "/cakes" }
    ];

    const topLocations = [
        { label: "Delhi", href: "/cakes/delhi" },
        { label: "Mumbai", href: "/cakes/mumbai" },
        { label: "Bangalore", href: "/cakes/bangalore" },
        { label: "Hyderabad", href: "/cakes/hyderabad" },
        { label: "Chennai", href: "/cakes/chennai" },
        { label: "Pune", href: "/cakes/pune" },
        { label: "Chandigarh", href: "/cakes/chandigarh" },
        { label: "Mohali", href: "/cakes/mohali" },
        { label: "Zirakpur", href: "/cakes/zirakpur" },
        { label: "Panchkula", href: "/cakes/panchkula" },
        { label: "Gurgaon", href: "/cakes/gurgaon" },
        { label: "Noida", href: "/cakes/noida" }
    ];

    return (
        <section className="silo-navigation-wrapper">
            <div className="silo-container">
                <div className="silo-grid">
                    <div className="silo-column">
                        <h4>Know About Cake Restro:</h4>
                        <div className="silo-links">
                            <Link to="/about-us">About Us</Link> | 
                            <Link to="/blogs">Blog</Link> | 
                            <Link to="/contact-us">Contact Us</Link> | 
                            <Link to="/faq">FAQ</Link> | 
                            <Link to="/sitemap">Sitemap</Link> | 
                            <Link to="/privacy-policy">Privacy Policy</Link> | 
                            <Link to="/terms-and-conditions">Terms & Policies</Link>
                        </div>
                    </div>

                    <div className="silo-column">
                        <h4>Cakes by Recipient:</h4>
                        <div className="silo-links">
                            {recipients.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Link to={item.href}>{item.label}</Link>
                                    {index < recipients.length - 1 && " | "}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                    <div className="silo-column">
                        <h4>Cakes by Category:</h4>
                        <div className="silo-links">
                            {categories.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Link to={item.href}>{item.label}</Link>
                                    {index < categories.length - 1 && " | "}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                    <div className="silo-column">
                        <h4>Festivals & Occasions:</h4>
                        <div className="silo-links">
                            {occasions.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Link to={item.href}>{item.label}</Link>
                                    {index < occasions.length - 1 && " | "}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                    <div className="silo-column">
                        <h4>Top Delivery Locations:</h4>
                        <div className="silo-links">
                            {topLocations.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Link to={item.href}>{item.label}</Link>
                                    {index < topLocations.length - 1 && " | "}
                                </React.Fragment>
                            ))}
                            {" | "}<Link to="/sitemap" className="view-all-silo">View All 600+ Cities</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SiloNavigation;
